export default __webpack_public_path__ + "static/media/281969.07ec72b4.png";